// extracted by mini-css-extract-plugin
export default {"main":"ChatBox_main__5X2bo","loadcontainer":"ChatBox_loadcontainer__RanVG","container":"ChatBox_container__VT14o","link":"ChatBox_link__d795t"};